import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { QRCodeWrapperModule } from '../shared/qrcode-wrapper.module';
import { DialogModule } from 'primeng/dialog';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';

import {
  ReleaseNotesComponent,
  TicketsListComponent,
  TicketsDashboardComponent,
  TicketViewComponent,
  TicketStatusComponent,
  PermissionsComponent,
  NavigationLinksComponent,
  NavigationCategoriesComponent

} from '.';
import { TicketListItemComponent } from './tickets/components/ticket-list-item/ticket-list-item/ticket-list-item.component';
function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}


const routes: Routes = [
  { path: 'releasenotes', component: ReleaseNotesComponent, canActivate: [AuthGuard] },
  { path: 'tickets', component: TicketsDashboardComponent, canActivate: [AuthGuard] },
  { path: 'tickets/list', component: TicketsListComponent, canActivate: [AuthGuard] },
  { path: 'tickets/:ID', component: TicketViewComponent, canActivate: [AuthGuard] },
  { path: 'ticket/status', component: TicketStatusComponent, canActivate: [AuthGuard] },
  { path: 'ticket/status/:ID', component: TicketStatusComponent, canActivate: [AuthGuard] },
  { path: 'permission', component: PermissionsComponent, canActivate: [AuthGuard] },
  { path: 'permission/:ID', component: PermissionsComponent, canActivate: [AuthGuard] },
  { path: 'navigation/links', component: NavigationLinksComponent, canActivate: [AuthGuard] },
  { path: 'navigation/links/:ID', component: NavigationLinksComponent, canActivate: [AuthGuard] },
  { path: 'navigation/categories', component: NavigationCategoriesComponent, canActivate: [AuthGuard] },
];

const pages = [
  ReleaseNotesComponent,
  TicketsListComponent,
  TicketsDashboardComponent,
  TicketViewComponent,
  TicketStatusComponent,
  PermissionsComponent,
  NavigationLinksComponent,
  NavigationCategoriesComponent
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,
    QRCodeWrapperModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    ...pages,
    TicketListItemComponent
  ],
  providers: []
})
export class SupportModule { 
  constructor(@Optional() @SkipSelf() parentModule: SupportModule) {
    if (parentModule) {
      throw new Error('Module is already loaded. Import in your base AppModule only.');
    }
  }
}
